import React from 'react';
import { Link } from 'react-router-dom';
import Layout from '../../layout/Layout';
import './styles.scss';

export const NotFound: React.FC = () => {
  return (
    <Layout>
      <div className="not-found-page">
        <div className="not-found-content">
          <div className="not-found-text">
            <h1>Oops, page not found</h1>
            <p>
              The page you're looking for doesn't exist. Go back to{' '}
              <Link className="bold" to="/">
                Home
              </Link>
            </p>
          </div>
        </div>
      </div>
    </Layout>
  );
};
